export enum HttpCallStatus {
  Failed = 'failed',
  Idle = 'idle',
  Loading = 'loading',
  Succeeded = 'succeeded'
}

export enum AuthMethod {
  Password = 'pwd-auth',
  CognitoManagedSSO = 'cm-auth',
  WorkOSManagedSSO = 'wosm-auth',
}

export interface ILoginOption {
  method: AuthMethod;
  id: string | null;
}

export interface ILoginOptionsResponse {
  options: ILoginOption[];
}

